import { ErrorHandler } from '@angular/core';

export class WizdomErrorHandler implements ErrorHandler {
	constructor () {
		console.log("Loaded WizdomErrorHandler");
	};
	handleError(error: object) {
		console.log("Custom Exception Captured");
		console.log(error);
	};
}